import useStoreGridState from 'features/queue/newGrid/hooks/useStoreGridState';
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_SELECTOR } from 'features/queue/newGrid/consts';

const useDefaultPageSize = (): number => {
    const { getGridState } = useStoreGridState();

    const gridState = getGridState();
    if (!gridState) {
        return DEFAULT_PAGE_SIZE;
    }

    const { pageSize } = gridState;
    if (!pageSize) {
        return DEFAULT_PAGE_SIZE;
    }

    if (!PAGE_SIZE_SELECTOR.includes(pageSize)) {
        return DEFAULT_PAGE_SIZE;
    }

    return pageSize;
}

export default useDefaultPageSize;